module.exports = __webpack_public_path__ + "static/media/fi-rr-download.59ac23b5.svg";